import CardTheme from './Card';
import tableTheme from './Table';
import inputTheme from './input';
import selectTheme from './select';

const components = {
  Card: CardTheme,
  Input: inputTheme,
  Table: tableTheme,
  Select: selectTheme,
};

export default components;
